import { logWarning } from '@marketplace-web/observability/logging-util'

const INCOGNIA_FEATURE_NAME = 'incognia'

export const logIncogniaWarning = (message: string, extra?: Record<string, unknown>) => {
  logWarning(message, {
    feature: INCOGNIA_FEATURE_NAME,
    extra: extra ? JSON.stringify(extra) : undefined,
  })
}
